/* Native custom-product steppers retain existing pricing and artwork listeners. */
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-wb-native-step]');
  if (!button) return;
  const input = button.closest('.wb-quantity-control')?.querySelector('input[type="number"]');
  if (!input || input.disabled || input.readOnly) return;
  const min = Number(input.min || 1);
  const max = input.max === '' ? Infinity : Number(input.max);
  if (!Number.isFinite(input.valueAsNumber) || input.valueAsNumber < min) input.value = min;
  else if (button.dataset.wbNativeStep === 'plus') input.stepUp();
  else input.stepDown();
  input.value = Math.max(min, Math.min(max, input.valueAsNumber));
  input.dispatchEvent(new Event('input', {bubbles:true}));
  input.dispatchEvent(new Event('change', {bubbles:true}));
});
